import React from 'react'
import { observer } from 'mobx-react'

const Grid = observer(class Grid extends React.Component {
  render () {
    let { children = [], rowHeight = '20px', height = 4, columns = 1, gap } = this.props

    let style = {
      gridRow: 'auto / span ' + height,
      gridColumn: 'auto / span 1',
      position: 'relative',
      overflowX: 'hidden',
      maxHeight: '100%'
    }
    children = children.map((i, index) => <div key={index} style={style}>{children[index]}</div>)
    return (
      <div style={{
        display: 'grid',
        gridAutoRows: rowHeight,
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridGap: gap
      }}>
        {children}
      </div>
    )
  }
})

export default Grid
